import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { addBrandsList } from "../redux/slices/brandsSlice";
import { BreadCrumbSecttion } from "../component/BreadCrumbSecttion";
import { Container, Row, Col, Form } from "react-bootstrap";
import Loader from "../component/Loader";
import { useNavigate } from "react-router-dom";
import InputField from "../component/InputField";
import PrimaryGradientButton from "../component/PrimaryGradientButton";
import SelectDropDown from "../component/SelectDropDown";
import OtherService from "../services/Other";
import DefaultImage from "../assets/images/logo-small.png";
import AlertMsg from "../component/AlertMsg";
import RegistrationService from "../services/registration";
import toast from "react-hot-toast";
import LeadService from "../services/Lead";
import ProfileService from "../services/Profile";
import { IMAGE_BASE_URL } from "../constants/common";
import {
  ValidatePhoneNumber,
  validateEmail,
} from "../constants/commonFunction";

const NewSiteRegistration = (route, navigation) => {
  const dispatch = useDispatch();
  const currentBrand = useSelector((state) => state.userTypeSlice.currentBrand);
  const brandsList = useSelector((state) => state.brands.brandsList);
  const userInfo = JSON.parse(localStorage.getItem("userData")).description;
  const navigate = useNavigate();
  const [isButtonLoading, setIsButtonLoading] = useState(false);
  const [isPersonaList, setIsPersonaList] = useState([]);
  const [selectPersonaList, setSelectPersonaList] = useState({
    id: "",
    title: "",
  });
  const [isInfluencerList, setIsInfluencerList] = useState([]);
  const [selectInfluencerList, setSelectInfluencerList] = useState({
    id: "",
    title: "",
  });
  const [serviceRegistrationData, setServiceRegistrationData] = useState({
    customerName: "",
    mobile: "",
    serviceDate: "",
  });
  const [isLoginSuccess, setIsLoginSuccess] = useState({
    isLogin: true,
    heading: "",
    text: "",
  });
  const [showAlert, setShowAlert] = useState(false);
  const [serviceChoose, setServiceChoose] = useState({
    id: "",
    title: "",
    productImage: "",
  });
  const handleServiceChange = (selected) => {
    setServiceChoose(selected);
    setServiceNameValidationError("");
  };
  const handleTalukaChange = (selected) => {
    setServiceChoose(selected);
    setServiceNameValidationError("");
  };
  const handleStateChange = (selected) => {
    setServiceChoose(selected);
    setServiceNameValidationError("");
  };
  const [serviceNameValidationError, setServiceNameValidationError] =
    useState("");
  const [selectPersonaValidationError, setSelectPersonaValidationError] =
    useState("");
  const [influencerNameValidationError, setInfluencerNameValidationError] =
    useState("");
  const [customerNameValidationError, setCustomerNameValidationError] =
    useState("");
  const [mobileValidationError, setMobileValidationError] = useState("");
  const [emailValidationError, setEmailValidationError] = useState("");
  const [addressValidationError, setAddressValidationError] = useState("");
  const [assignToValidationError, setAssignToValidationError] = useState("");
  const [stateValidationError, setStateValidationError] = useState("");
  const [districtValidationError, setDistrictValidationError] = useState("");
  const [postalCodeValidationError, setPostalCodeValidationError] =
    useState("");
  const [talukaValidationError, setTalukaValidationError] = useState("");
  const [brandValidationError, setBrandValidationError] = useState("");
  const [productValidationError, setProductValidationError] = useState("");
  const [quantityValidationError, setQuantityValidationError] = useState("");
  const [sitenameValidationError, setSitenameValidationError] = useState("");
  const [remarksValidationError, setRemarksValidationError] = useState("");
  const [serviceList, setServiceList] = useState([]);
  const [selectedDistrict, setSelectedDistrict] = useState({
    id: "",
    title: "",
  });
  const [allTaluka, setAllTaluka] = useState([]);
  const [selectedTaluka, setSelectedTaluka] = useState({
    id: "",
    title: "",
    ext_taluka_code: "",
  });
  const [selectedState, setSelectedState] = useState({ id: "", title: "" });
  const [allStates, setAllStates] = useState([]);
  const [assignToName, setAssignToName] = useState("");
  const [assignTo, setAssignTo] = useState("");
  const [selLang, setSelLang] = useState("");
  const [selectedCustomerType, setSelectedCustomerType] = useState({
    id: "IHB Site",
    title: "IHB",
  });
  const [check, setCheck] = useState(1);
  const [selectedCountry, setSelectedCountry] = useState({ id: "", title: "" });
  const [allProducts, setAllProducts] = useState([]);
  const [addressLine1, setAddressLine1] = useState("");
  const [addressLine2, setAddressLine2] = useState("");
  const [name, setName] = useState("");
  const [mobileno, setMobileno] = useState("");
  const [email, setEmail] = useState("");
  const [address, setAddress] = useState("");
  const [quantity, setQuantity] = useState("");
  const [selectedProduct, setSelectedProduct] = useState({
    id: "",
    title: "",
    prodCode: "",
    prodImage: "",
    prodPrice: "",
    prodUnit: "",
  });
  const [siteName, setSiteName] = useState("");
  const [remarks, setRemark] = useState("");
  const [postCode, setPostcode] = useState("");
  const [mobErr, setMobErr] = useState("");
  const [emailErr, setEmailErr] = useState("");
  const [pinErr, setPinErr] = useState("");
  const [loading, setLoading] = useState(false);
  const [allBrand, setAllBrand] = useState([]);
  const [brandId, setBrandId] = useState("");
  const [allDistrict, setAllDistrict] = useState([]);
  const [allCountries, setAllCountries] = useState([]);
  const [selectedBrand, setSelectedBrand] = useState(currentBrand);
  const [constructionDetails, setConstructionDetails] = useState([]);
  const [constructionStatusList, setConstructionStatusList] = useState([]);
  const [constructionStageList, setConstructionStageList] = useState([]);
  const [selectedConstructionStatus, setSelectedConstructionStatus] = useState({
  id: "",
  title: "",
});

const [selectedConstructionStage, setSelectedConstructionStage] = useState({
  id: "",
  title: "",
});
const [floorData, setFloorData] = useState([]);
const [selectedFloor, setSelectedFloor] = useState({ id: "", title: "" });

  const handleServiceRegistrationInput = (e) => {
    const { name, value } = e.target;
    const numberPattern = new RegExp(/^\d*$/);
    if (name == "customerName") {
      const customerNameRegex = /^[a-zA-Z]*$/;
      if (customerNameRegex.test(value) || value.length === 0) {
        setCustomerNameValidationError("");
      } else {
        setCustomerNameValidationError("Invalid customer name");
        return;
      }
    }
    if (name == "mobile") {
      const mobileRegex = /[0-9]/;
      if (mobileRegex.test(value) || value.length === 0) {
        setMobileValidationError("");
      } else {
        setMobileValidationError("Invalid mobile number");
        return;
      }
    }
    if (name === "mobile" && !numberPattern.test(value)) return;
    setServiceRegistrationData({ ...serviceRegistrationData, [name]: value });
  };

  useEffect(() => {
    setSelectedDistrict({ id: "", title: "" });
    setSelectedTaluka({ id: "", title: "", ext_taluka_code: "" });
    setAllTaluka([]);
  }, [selectedState]);

  useEffect(() => {
    setSelectedTaluka({ id: "", title: "", ext_taluka_code: "" });
  }, [selectedDistrict]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const assignToResponse = await LeadService.assignToList();
        if (assignToResponse.statusCode === 401) {
          //   logoutHandler(navigation);
          return;
        }
        if (!assignToResponse.error) {
          setAssignTo(assignToResponse.data.TSE_id);
          setAssignToName(assignToResponse.data["TSE Name"]);
        }
      } catch (error) {
        console.error("Error fetching data:");
      }
    };
    fetchData();
  }, []);

  useEffect(() => {
    if (brandsList && brandsList.length > 0) {
      setAllBrand(brandsList);
      return;
    }
    const fetchBrands = async () => {
      try {
        const res = await ProfileService.getBrand();
        if (res.success) {
          const allBrands = res.response.message.map((item) => ({
            id: String(item.brandId),
            title: item.brandName,
            image: item.brandLogo,
          }));

          setAllBrand(allBrands);
          dispatch(addBrandsList({ brandsList: allBrands }));
          //   setSelectedBrand(brandId === 1 ? allBrands[0] : allBrands[1]);
        }
      } catch (error) {
        console.error("Error fetching brands:");
      }
    };
    fetchBrands();
  }, [brandId]);

  useEffect(() => {
    const fetchDistricts = async () => {
      try {
        if (selectedState.id && selectedCountry.id) {
          const res = await RegistrationService.allDistricts(
            selectedCountry.id,
            selectedState.id,
          );
          if (res.success) {
            const districts = res.response.districtDetails.map((dis) => ({
              id: dis.id,
              title: dis.name,
            }));
            setAllDistrict(districts);
          }
        }
      } catch (error) {
        console.error("Error fetching districts:");
      }
    };
    fetchDistricts();
  }, [selectedState, selectedCountry]);

  const getCountryList = async () => {
    try {
      const res = await RegistrationService.allCountries();
      if (res.success) {
        const allCountriesList = res.response.countriesDetails
          .filter((item) => ["India"].includes(item.name))
          .map((item) => ({ id: item.id, title: item.name }));
        setAllCountries(allCountriesList);
        if (allCountriesList.length > 0) {
          setSelectedCountry(allCountriesList[0]);
        }
      } else {
        console.error("Error fetching countries:");
      }
    } catch (err) {
      console.error("Error:");
    }
  };

  const getStateList = async (cid) => {
    try {
      const res = await RegistrationService.allStates(cid);
      if (res.success) {
        const allState = res.response.statesDetails.map((item) => ({
          id: item.id,
          title: item.name,
        }));
        setAllStates(allState);
      } else {
        console.error("Error fetching states:");
      }
    } catch (err) {
      console.error("Error:");
    }
  };

  const getCityList = async (cid, sid) => {
    try {
      const res = await RegistrationService.allCities(cid, sid);
      if (res.success) {
        const allCity = res.response.citiesDetails.map((item) => ({
          id: item.id,
          title: item.name,
        }));
        // setAllCities(allCity);
      } else {
        console.error("Error fetching cities:");
      }
    } catch (err) {
      console.error("Error:");
    }
  };

  useEffect(() => {
    getCountryList();
  }, []);

  useEffect(() => {
    if (selectedCountry.id) {
      getStateList(selectedCountry.id);
    }
  }, [selectedCountry]);

  useEffect(() => {
    if (selectedState.id) {
      getCityList(selectedCountry.id, selectedState.id);
    }
  }, [selectedState]);

  useEffect(() => {
    const fetchTalukas = async () => {
      if (selectedDistrict?.id) {
        try {
          const token = localStorage.getItem("access_token");
            const res = await RegistrationService.talukasByDistrict(
              selectedDistrict.id,
              token
            );
            if (res.success) {
              const talukas = res.response.talukaDetails.map((taluka) => ({
                id: taluka.id,
                title: taluka.name,
                ext_taluka_code: taluka.ext_taluka_code,
              }));
              setAllTaluka(talukas);
            } else {
              console.error("Error in response:");
            }
        } catch (err) {
          console.error("Error fetching talukas:");
        }
      }
    };
    fetchTalukas();
  }, [selectedDistrict]);

  useEffect(() => {
    if (!brandsList || brandsList.length === 0) {
      return;
    }
    setAllBrand(brandsList);
    if (brandId === 1) {
      // setSelectedBrand(brandsList[0]);
    } else {
      // setSelectedBrand(brandsList[1]);
    }
  }, [brandId, brandsList]);

  useEffect(() => {
    const fetchProducts = async () => {
      if (selectedBrand.id) {
        try {
          const res = await RegistrationService.getProductNames(
            selectedBrand.id,
          );
          if (!res.error) {
            const products = res.response.ProductDetails.map((item) => ({
              id: item.id,
              title: item.product_name,
              prodCode: item.product_code,
              image: `${IMAGE_BASE_URL}${item.product_image}`,
              prodPrice: item.price,
              prodUnit: item.unit_name,
            }));
            setAllProducts(products);
          } else {
            console.error("Error in product response:");
          }
        } catch (err) {
          console.error("Error fetching products:");
        }
      }
    };
    fetchProducts();
  }, [selectedBrand]);

  useEffect(() => {
    const PersonaSelectionList = async () => {
      try {
        const PersonaSelectFetch = await RegistrationService.getHierarchies();
        if (PersonaSelectFetch.success == true) {
          if (PersonaSelectFetch.response.hierarchiesDetails.length > 0) {
            const hierchiesList =
              PersonaSelectFetch.response.hierarchiesDetails.map((item) => ({
                id: item.id,
                title: item.name,
              }));
            setIsPersonaList(hierchiesList);
          }
        }
      } catch (e) {
      }
    };
    PersonaSelectionList();
  }, []);

  useEffect(() => {
    const ProductFetch = async () => {
      try {
        const ProductFetchResponse = await OtherService.serviceProductList();
        if (
          ProductFetchResponse.success == true &&
          ProductFetchResponse.response.ProductDetails.length > 0
        ) {
          const filteredData = ProductFetchResponse.response.ProductDetails.map(
            (item, index) => {
              const productImageSrc =
                item.product_image == null
                  ? DefaultImage
                  : `https://dev-adani-dms.mjunction.in${item.product_image}`;
              return {
                id: item.id,
                title: item.product_name,
                productImage: productImageSrc,
              };
            }
          );
          setIsButtonLoading();
          setServiceList(filteredData);
        }
      } catch (e) {
      }
    };
    ProductFetch();
  }, []);

  // useEffect(() => {
  //     const InfluencerFetch = async () => {
  //         try {
  //             const token = localStorage.getItem("access_token");

  //             const InfluencerFetchResponse = await RegistrationService.getInfluencers(selectPersonaList.id, token)

  //             if (InfluencerFetchResponse.success == true) {
  //                 if (InfluencerFetchResponse.response.saleContractorDetails.length > 0) {
  //                     setIsInfluencerList(InfluencerFetchResponse.response.saleContractorDetails.map((item) => {
  //                         return {
  //                             id: item.dcm_contacts_id,
  //                             title: item.full_name,
  //                         }
  //                     }))
  //                 }
  //             }
  //         }
  //         catch (e) {

  //         }
  //     }
  //     InfluencerFetch()
  // }, [selectPersonaList])

  useEffect(() => {
    const InfluencerFetch = async () => {
      try {
        if (!selectPersonaList.id) {
          console.warn("No persona selected. Skipping API call.");
          return;
        }
        const InfluencerFetchResponse =
        await RegistrationService.getInfluencers(selectPersonaList.id);
        if (InfluencerFetchResponse?.success) {
          const { saleContractorDetails } =
            InfluencerFetchResponse.response || {};
          if (saleContractorDetails?.length > 0) {
            setIsInfluencerList(
              saleContractorDetails.map((item) => ({
                id: item.dcm_contacts_id,
                title: item.full_name,
              }))
            );
          } else {
            console.info("No influencers found for the selected persona.");
          }
        } else {
          console.error(
            "API call unsuccessful:");
        }
      } catch (e) {
        console.error("Error fetching influencers:");
      }
    };
    InfluencerFetch();
  }, [selectPersonaList.id]);

  useEffect(() => {
  const fetchConstructionDetails = async () => {
    if (!selectedBrand?.id) return;
    try {
      const res = await LeadService.getConstructionDetails(selectedBrand.id);
      if (res?.data) {
        setConstructionDetails(res.data);
        const groupedStageStatus = res.data.grouped_stage_status || {};
        const statusOptions = Object.keys(groupedStageStatus).map((status) => ({
          id: status,
          title: status,
        }));
        setConstructionStatusList(statusOptions);
        setConstructionStageList([]);
      }
    } catch (error) {
      console.error("Error fetching construction details:", error);
    }
  };

  fetchConstructionDetails();
}, [selectedBrand]);

useEffect(() => {
  if (!selectedConstructionStatus.id || !constructionDetails.grouped_stage_status) {
    setConstructionStageList([]);
    return;
  }
  const stages =
    constructionDetails.grouped_stage_status[
      selectedConstructionStatus.id
    ] || [];
  setConstructionStageList(
    stages.map((stage) => ({
      id: stage.id,
      title: stage.name,
    }))
  );
  setSelectedConstructionStage({
    id: "",
    title: "",
  });
}, [selectedConstructionStatus, constructionDetails]);

useEffect(() => {
  setSelectedFloor({ id: "", title: "" });
  if(selectedConstructionStage.id) {
      const floors = constructionDetails.grouped_param_vlues.find(item => (item.stage_id == selectedConstructionStage.id && selectedConstructionStatus.id == item.status_name));
      console.log("floors data==============>",floors);
      if(!floors?.floors) {
        setFloorData([]);
        return;
      }
      console.log(Object.entries(floors.floors))
      const fd = Object.entries(floors.floors).map(([key, value]) => ({
        id: key,
        title: value
      }));
      console.log(fd);
      setFloorData(fd);
    }
}, [selectedConstructionStage]);

  const handlePersonaChange = (selectedValue) => {
    setSelectPersonaList(selectedValue);
    setSelectPersonaValidationError("");
  };

  const handleInfluencerChange = (selectedValue) => {
    setSelectInfluencerList(selectedValue);
    setInfluencerNameValidationError("");
  };

  const customerType = [
    // {
    //   id: "BNI Site",
    //   title: "B&I",
    // },
    {
      id: "IHB Site",
      title: "IHB",
    },
    // {
    //   id: "Non Trade",
    //   title: "Non-Trade",
    // },
  ];

  function resetFields() {
    setAddressLine1("");
    setAddress("")
    setSelectedState({ id: "", title: "" });
    setPostcode("");
    setSiteName("");
    setRemark("");
    setSelectedConstructionStatus({ id: "", title: "" });
    setSelectedConstructionStage({ id: "", title: "" });
    setSelectedFloor({ id: "", title: "" });
    setAddressLine2("");
    setName("");
    setMobileno("");
    setEmail("");
    setSelectedDistrict({ id: "", title: "" });
    setSelectedCustomerType({ id: "IHB Site", title: "IHB" });
  }

  const handleServiceRegistrationSubmit = async () => {
  setCheck((p) => p + 1);

  const hierId = JSON.parse(localStorage.getItem("userData"))?.dcm_hierarchies_id;

  if (!selectedCustomerType.id) {
    toast.error("Please select Customer Type");
    return;
  }

  if (!name?.trim()) {
    toast.error("Please enter Name");
    return;
  }

  if (!mobileno) {
    toast.error("Please enter Mobile Number");
    return;
  }

  if (!ValidatePhoneNumber(mobileno, setMobErr, setMobileno)) {
    return;
  }

  if (email && !validateEmail(email, setEmailErr, setEmail)) {
    return;
  }

  if (!selectedState.id) {
    toast.error("Please select State");
    return;
  }

  if (!selectedDistrict.id) {
    toast.error("Please select District");
    return;
  }

  if (!selectedTaluka.id) {
    toast.error("Please select Taluka");
    return;
  }

  if (!address?.trim()) {
    toast.error("Please enter Address");
    return;
  }

  if (!postCode) {
    toast.error("Please enter Pincode");
    return;
  }

  if (postCode.length !== 6) {
    setPinErr("Pincode must be six digits");
    toast.error("Pincode must be six digits");
    return;
  }

  if (!assignTo) {
    toast.error("Please select Assign To");
    return;
  }

  if (!hierId) {
    toast.error("Hierarchy not found");
    return;
  }

  if (!remarks?.trim()) {
    toast.error("Please enter Remarks");
    return;
  }

  if (
    selectedCustomerType.id === "IHB Site" ||
    selectedCustomerType.id === "BNI Site"
  ) {
    if (!siteName?.trim()) {
      toast.error("Please enter Site Name");
      return;
    }
  }

  if (selectedCustomerType.id === "IHB Site") {
    if (!selectedBrand.id) {
      toast.error("Please select Brand");
      return;
    }

    if (!selectedConstructionStage.id) {
      toast.error("Please select Construction Stage");
      return;
    }

    if (!selectedFloor.id) {
      toast.error("Please select Floor");
      return;
    }
  }

  if (selectedCustomerType.id === "Non Trade") {
    if (!selectedProduct.prodCode) {
      toast.error("Please select Product");
      return;
    }

    if (!quantity || Number(quantity) <= 0) {
      toast.error("Please enter valid Quantity");
      return;
    }
  }

  setLoading(true);

  let payload = {};

  switch (selectedCustomerType.id) {
    case "IHB Site":
      payload = {
        customerType: selectedCustomerType.id,
        name,
        mobileNumber: String(mobileno),
        email,
        addressLine1: address,
        addressLine2,
        siteName,
        talukaName: selectedTaluka.ext_taluka_code,
        districtId: selectedDistrict.id,
        assignTo: parseInt(assignTo),
        hierarchyId: parseInt(hierId),
        postCode,
        statesId: parseInt(selectedState.id),
        citiesId: 0,
        remarks,
        constructionStageId: parseInt(selectedConstructionStage.id),
        floorNo: parseInt(selectedFloor.id),
        brandId: parseInt(selectedBrand.id),
      };
      break;

    case "BNI Site":
      payload = {
        customerType: selectedCustomerType.id,
        name,
        mobileNumber: String(mobileno),
        email,
        addressLine1: address,
        addressLine2,
        siteName,
        talukaName: selectedTaluka.ext_taluka_code,
        districtId: selectedDistrict.id,
        assignTo: parseInt(assignTo),
        hierarchyId: parseInt(hierId),
        postCode,
        statesId: parseInt(selectedState.id),
        citiesId: 0,
        remarks,
      };
      break;

    case "Non Trade":
      payload = {
        customerType: selectedCustomerType.id,
        name,
        mobileNumber: String(mobileno),
        email,
        addressLine1: address,
        addressLine2,
        districtId: selectedDistrict.id,
        talukaName: selectedTaluka.ext_taluka_code,
        assignTo: parseInt(assignTo),
        hierarchyId: parseInt(hierId),
        postCode,
        statesId: parseInt(selectedState.id),
        remarks,
        siteName,
        productItems: [
          {
            Productcode: selectedProduct.prodCode,
            Quantity: parseFloat(quantity),
          },
        ],
      };
      break;
  }

  try {
    const res = await LeadService.createLead(payload);
    setLoading(false);
    if (!res.error) {
      toast.success(res?.data?.message);
      resetFields();
    } else {
      toast.error(res.errorMessage || "Failed to create lead");
    }
  } catch (err) {
    setLoading(false);
    toast.error("Something went wrong");
  }
};

  return (
    <>
      {/* {loading && <Loader />} */}
      <BreadCrumbSecttion
        pageTitle="New Site Registration"
        currentPageName="New Site Registration"
      />
      <section className="padTop50">
        <Container>
          <Row className="justify-content-center align-item-center h-100">
            <Col xs={12}>
              <div className="userInfoBox">
                <div className="dashboard-title">
                  <h4 className="gradient-text">
                    Please Register Your New Site
                  </h4>
                </div>
                <div className="dashboard-details">
                  <Row>
                    {userInfo == "Dealer" && (
                      <Col xs={12} lg={3}>
                        <SelectDropDown
                          labelName="Select Persona"
                          requiredStar="*"
                          options={isPersonaList}
                          selectedValue={selectPersonaList}
                          setSelectedValue={setSelectPersonaList}
                          onChange={handlePersonaChange}
                          page="searchFilter"
                        />
                        {selectPersonaValidationError && (
                          <div className="error-message">
                            {selectPersonaValidationError}
                          </div>
                        )}
                      </Col>
                    )}
                    {userInfo == "Dealer" && (
                      <Col xs={12} lg={3}>
                        <SelectDropDown
                          labelName="Select Influencer"
                          requiredStar="*"
                          options={isInfluencerList}
                          selectedValue={selectInfluencerList}
                          setSelectedValue={setSelectInfluencerList}
                          onChange={handleInfluencerChange}
                          page="searchFilter"
                        />
                        {influencerNameValidationError && (
                          <div className="error-message">
                            {influencerNameValidationError}
                          </div>
                        )}
                      </Col>
                    )}

                    <Col xs={12} lg={3}>
                      <SelectDropDown
                        labelName="Customer Type"
                        requiredStar="*"
                        options={customerType}
                        selectedValue={selectedCustomerType}
                        setSelectedValue={setSelectedCustomerType}
                        check={check}
                        // onChange={handleServiceChange}
                        page="searchFilter"
                        disabled={true}
                      />
                      {serviceNameValidationError && (
                        <div className="error-message">
                          {serviceNameValidationError}
                        </div>
                      )}
                    </Col>

                    <Col xs={12} lg={3}>
                      <InputField
                        requiredStar="*"
                        inputFieldLabel="Name"
                        name="name"
                        value={name}
                        onChange={(e) => {
                          setName(e.target.value.replace(/[^a-zA-Z\s]/g, ""));
                        }}
                      />
                      {customerNameValidationError && (
                        <div className="error-message">
                          {customerNameValidationError}
                        </div>
                      )}
                    </Col>

                    <Col xs={12} lg={3}>
                      <InputField
                        inputFieldLabel="Mobile No"
                        requiredStar="*"
                        name="mobile"
                        value={mobileno}
                        onChange={(e) => {
                          const numericValue = e.target.value.replace(/\D/g, "");
                          if (
                            numericValue.length <= 10 &&
                            (numericValue === "" || /^[6-9]/.test(numericValue))
                          ) {
                            setMobileno(numericValue);
                          }
                        }}
                        maxLength={10}
                      />
                      {mobileValidationError && (
                        <div className="error-message">
                          {mobileValidationError}
                        </div>
                      )}
                    </Col>

                    <Col xs={12} lg={3}>
                      <InputField
                        inputFieldLabel="Email"
                        name="email"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        regex={
                          /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
                        }
                      />
                      {emailValidationError && (
                        <div className="error-message">
                          {emailValidationError}
                        </div>
                      )}
                    </Col>

                    <Col xs={12} lg={3}>
                      <InputField
                        inputFieldLabel="Address"
                        requiredStar="*"
                        name="address"
                        value={address}
                        onChange={(e) => {
                          setAddress(e.target.value.replace(/[^a-zA-Z0-9\s,-]/g, ""));
                        }}
                      />
                      {addressValidationError && (
                        <div className="error-message">
                          {addressValidationError}
                        </div>
                      )}
                    </Col>

                    <Col xs={12} lg={3}>
                      <InputField
                        inputFieldLabel="Assign To"
                        name="assignTo"
                        editable={false}
                        selectTextOnFocus={false}
                        required={true}
                        value={assignToName}
                      />
                      {assignToValidationError && (
                        <div className="error-message">
                          {assignToValidationError}
                        </div>
                      )}
                    </Col>

                    <Col xs={12} lg={3}>
                      <SelectDropDown
                        labelName="State"
                        requiredStar="*"
                        options={allStates}
                        selectedValue={selectedState}
                        setSelectedValue={setSelectedState}
                        onChange={handleStateChange}
                        page="searchFilter"
                      />
                      {stateValidationError && (
                        <div className="error-message">
                          {stateValidationError}
                        </div>
                      )}
                    </Col>

                    <Col xs={12} lg={3}>
                      <SelectDropDown
                        labelName="District"
                        requiredStar="*"
                        options={allDistrict}
                        selectedValue={selectedDistrict}
                        setSelectedValue={setSelectedDistrict}
                        onChange={handleServiceChange}
                        page="searchFilter"
                      />
                      {serviceNameValidationError && (
                        <div className="error-message">
                          {serviceNameValidationError}
                        </div>
                      )}
                    </Col>

                    <Col xs={12} lg={3}>
                      <InputField
                        inputFieldLabel="Postal Code"
                        requiredStar="*"
                        name="postCode"
                        value={postCode}
                        onChange={(e) => {
                          const numericValue = e.target.value.replace(/\D/g, "");
                          if (numericValue.length <= 6) {
                            setPostcode(numericValue);
                          }
                        }}
                        maxLength={6}
                      />
                      {postalCodeValidationError && (
                        <div className="error-message">
                          {postalCodeValidationError}
                        </div>
                      )}
                    </Col>

                    <Col xs={12} lg={3}>
                      <SelectDropDown
                        labelName="Taluka"
                        requiredStar="*"
                        options={allTaluka}
                        selectedValue={selectedTaluka}
                        setSelectedValue={setSelectedTaluka}
                        onChange={handleTalukaChange}
                        page="searchFilter"
                      />
                      {talukaValidationError && (
                        <div className="error-message">
                          {talukaValidationError}
                        </div>
                      )}
                    </Col>

                    {selectedCustomerType.id == "Non Trade" && (
                      <Col xs={12} lg={3}>
                        <SelectDropDown
                          labelName="Brand"
                          requiredStar="*"
                          options={allBrand}
                          selectedValue={selectedBrand}
                          setSelectedValue={setSelectedBrand}
                          onChange={handleServiceChange}
                          page="searchFilter"
                        />
                        {brandValidationError && (
                          <div className="error-message">
                            {brandValidationError}
                          </div>
                        )}
                      </Col>
                    )}

                    {selectedCustomerType.id == "Non Trade" && (
                      <Col xs={12} lg={3}>
                        <SelectDropDown
                          labelName="Select Product"
                          requiredStar="*"
                          options={allProducts}
                          selectedValue={selectedProduct}
                          setSelectedValue={setSelectedProduct}
                          onChange={handleServiceChange}
                          page="searchFilter"
                        />
                        {productValidationError && (
                          <div className="error-message">
                            {productValidationError}
                          </div>
                        )}
                      </Col>
                    )}

                    {selectedCustomerType.id == "Non Trade" && (
                      <Col xs={12} lg={3}>
                        <InputField
                          inputFieldLabel="Quantity"
                          requiredStar="*"
                          name="quantity"
                          value={quantity}
                          setSelectedValue={setQuantity}
                          onChange={(e) => {
                            if (e.target.value.length <= 9) {
                              setQuantity(e.target.value);
                              // handleNewSiteRegistrationInput(e);
                            }
                          }}
                          maxLength={9}
                        />
                        {quantityValidationError && (
                          <div className="error-message">
                            {quantityValidationError}
                          </div>
                        )}
                      </Col>
                    )}

                    <Col xs={12} lg={3}>
                      <InputField
                        inputFieldLabel="Site Name"
                        requiredStar="*"
                        name="siteName"
                        value={siteName}
                        onChange={(e) => setSiteName(e.target.value)}
                      />
                      {sitenameValidationError && (
                        <div className="error-message">
                          {sitenameValidationError}
                        </div>
                      )}
                    </Col>

                    <Col xs={12} lg={3}>
                      <SelectDropDown
                        labelName="Construction Status"
                        requiredStar="*"
                        options={constructionStatusList}
                        selectedValue={selectedConstructionStatus}
                        setSelectedValue={setSelectedConstructionStatus}
                        onChange={(selected) => {
                          setSelectedConstructionStatus(selected);
                          setSelectedConstructionStage({ id: "", title: "" });
                        }}
                        page="searchFilter"
                      />
                      {talukaValidationError && (
                        <div className="error-message">
                          {talukaValidationError}
                        </div>
                      )}
                    </Col>

                    <Col xs={12} lg={3}>
                      <SelectDropDown
                        labelName="Construction Stage"
                        requiredStar="*"
                        options={constructionStageList}
                        selectedValue={selectedConstructionStage}
                        setSelectedValue={setSelectedConstructionStage}
                        onChange={(selected) => setSelectedConstructionStage(selected)}
                        page="searchFilter"
                      />
                      {talukaValidationError && (
                        <div className="error-message">
                          {talukaValidationError}
                        </div>
                      )}
                    </Col>

                    {floorData.length > 0 && (
                      <Col xs={12} lg={3}>
                        <SelectDropDown
                          labelName="Floors"
                          requiredStar="*"
                          options={floorData}
                          selectedValue={selectedFloor}
                          setSelectedValue={setSelectedFloor}
                          onChange={(selected) => setSelectedFloor(selected)}
                          page="searchFilter"
                        />
                      </Col>
                    )}

                    <Col xs={12} lg={3}>
                      <InputField
                        inputFieldLabel="Remarks"
                        requiredStar="*"
                        name="remarks"
                        value={remarks}
                        onChange={(e) => setRemark(e.target.value)}
                      />
                      {remarksValidationError && (
                        <div className="error-message">
                          {remarksValidationError}
                        </div>
                      )}
                    </Col>
                   
                    <Col xs={12} lg={3}>
                      <Form.Label className="form-label" style={{ visibility: "hidden" }}>
                        &nbsp;
                      </Form.Label>
                      <PrimaryGradientButton
                        buttonText={
                          isButtonLoading ? "Processing..." : "Submit"
                        }
                        disabled={isButtonLoading}
                        onClick={handleServiceRegistrationSubmit}
                      />
                    </Col>
                    <Col xs={12} lg={3}>
                      {showAlert && (
                        <AlertMsg
                          alertBoxColor={
                            isLoginSuccess.isLogin
                              ? "successAlert"
                              : "FailedAlert"
                          }
                          heading={isLoginSuccess.heading}
                          text={isLoginSuccess.text}
                        />
                      )}
                    </Col>
                  </Row>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
};

export default NewSiteRegistration;
